// extracted by mini-css-extract-plugin
export default {"header":"ComponentPage_header__PK56W"};